import { createApiCallActions } from '../../../../common/store/generic.actions';
import { WorkLocationModel } from './types';

export const workLocationActions = {
  getById: createApiCallActions<WorkLocationModel>('workLocation', 'getById'),
  createInstance: createApiCallActions<WorkLocationModel>(
    'workLocation',
    'createInstance',
  ),
  add: createApiCallActions<WorkLocationModel>('workLocation', 'add'),
  update: createApiCallActions<WorkLocationModel>('workLocation', 'update'),
  delete: createApiCallActions<boolean>('workLocation', 'delete'),
};

export type WorkLocationAction = typeof workLocationActions;
